import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useHistory } from "react-router-dom";

import useState from "../../../Hooks/useState";
import DefaultButton from "../../Common/DefaultButton"
import PinCode from "../PinCode";
import { HOST } from "../../../Utils/constants";
import Axios from "axios";
import languagePack from "../../../Utils/language";
import globalContext from "../../../Hooks/globalContext";

const PageVIew = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  background-color: white;
`;


const PrePage = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.mainColor};
  width: 100%;
  height: 85vh;
  justify-content: center;
  padding: 10vw;
`;

const Clipboard = styled(CopyToClipboard)`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align:center;
  font-size: 14px;
  color: ${(props) => props.theme.darkGrey};
  text-decoration:underline;
  margin: 0;
  margin-bottom: 5px;
`;


const Notification = styled.div`
  color: white;
  font-size: 25px;
  line-height: 35px;
`;

const Footer = styled.div`
  background-color: white;
  height: 15vh;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const ButtonForm = styled.div`
  width: 30%;
`;

const NextText = styled.div`
  :hover {
    opacity: 0.75;
  }
  cursor: pointer;
  padding: 15px;
  font-size: 20px;
  font-weight: bold;
  color: ${(props) => props.theme.mainColor};
`;

const Key = styled.div`
font-size:20px;
margin-bottom:3px;
text-align:center;
`

const OTPNotification = styled.div`
color:red;
font-size:12px;
margin-bottom:20px;
`


const Container = () => {
  const pin = useState('');
  const phase = useState(0);
  const history = useHistory();
  const error = useState(null);
  const { httpHeader, modal, language } = useContext(globalContext);

  const isLoading = useState(false);

  const otpSecret = useState(null);


  const backOnPress = () => {
    history.goBack();
  };

  const nextOnPress = async (path) => {
    if (path === 1) {
      const { data } = await Axios.post(`${HOST}/user/otp/generate`, {}, httpHeader())
      otpSecret.setState(data.secret)
    }
    phase.setState(path);
  };

  const otpRegister = async () => {
    const pinNumber = pin.state;
    pin.setState("")
    const requestParams = {
      seed: otpSecret.state,
      token: Number(pinNumber)
    }

    const { data } = await Axios.post(`${HOST}/user/otp/generate`, requestParams, httpHeader())
    if (data.status) {
      modal.setState(languagePack("OTP가 등록되었습니다.", language.state));
      history.goBack();
    } else {
      switch (data.code) {
        case "invalid":
          error.setState(`* ${languagePack("잘못된 OTP 인증번호입니다.", language.state)}`);
          break;
        default:
          error.setState(`* ${languagePack("서버 오류입니다. 잠시 후에 다시 시도해주세요.", language.state)}`);
          break;
      }
    }

    isLoading.setState(false);
  }

  const onCopy = ({ copy }) => {
    modal.setState(languagePack("OTP 키가 복사되었습니다.", language.state));
  };

  useEffect(() => {
    if (pin.state.length > 5) {
      isLoading.setState(true);
      otpRegister();
    }
  });


  return (
    <PageVIew>
      {phase.state === 0 && (
        <>
          <PrePage>
            <Notification>{languagePack("OTP가", language.state)}</Notification>
            <Notification style={{ marginBottom: 30 }}>
              {languagePack("등록되지 않았습니다.", language.state)}
            </Notification>
            <Notification>{languagePack("새로운 OTP를 등록합니다.", language.state)}</Notification>
          </PrePage>
          <Footer>
            <ButtonForm onClick={backOnPress}>
              <NextText>{languagePack("이전", language.state)}</NextText>
            </ButtonForm>
            <ButtonForm onClick={nextOnPress.bind(null, 1)}>
              <NextText style={{ textAlign: "right" }}>{languagePack("다음", language.state)}</NextText>
            </ButtonForm>
          </Footer>
        </>
      )}
      {phase.state === 1 && (
        <div style={{ padding: 20, justifyContent: "center" }}>
          <Key>
            {otpSecret.state}
          </Key>
          <Clipboard text={otpSecret.state} onCopy={onCopy} >
            <div> {languagePack("클립보드로 복사", language.state)}</div>
          </Clipboard>
          <OTPNotification>
            {("Google OTP(Authenticator)") + " " + languagePack("앱에 해당 OTP 키를 입력해주세요.", language.state)}
          </OTPNotification>
          <DefaultButton text={languagePack("다음", language.state)} onClick={nextOnPress.bind(null, 2)} />
        </div>
      )}
      {phase.state === 2 && (
        <PinCode
          goBack={() => history.goBack()}
          pin={pin}
          error={error.state}
          title={languagePack("등록한 OTP의 6자리 번호를 입력해주세요.", language.state)}
          isLoading={isLoading.state}
        />
      )}
    </PageVIew>
  );
};

// G5ATQPJWNQRRWQYS

export default Container;
